import { cn } from '../../../../lib/utils/cn';
import { OfferDisplayStatus } from '../../constants/offer-display-status.enum';
import { OFFER_DISPLAY_STATUS } from '../../constants/offer-display-status';

export interface OfferStatusBadgeProps {
  status: OfferDisplayStatus;
}

/** Same chip as `products` `ArchiveBadge`, for the offer status. */
const OfferStatusBadge = ({ status }: OfferStatusBadgeProps) => {
  const config = OFFER_DISPLAY_STATUS[status];

  return (
    <span className={cn('text-[11px] font-semibold px-2 py-1 rounded-full inline-flex items-center gap-1.5 shrink-0', config.chip)}>
      <span className={cn('w-[7px] h-[7px] rounded-full shrink-0', config.lamp)} />
      {config.label}
    </span>
  );
};

export default OfferStatusBadge;
